import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

export const initAlpine = () => {
  window.Alpine = Alpine

  Alpine.store('navigation', {
    hoveredIndex: null,
    shapePos: { top: 0, left: 0, width: 0, height: 0 },

    updateShape(el, index) {
      this.hoveredIndex = index
      const rect = el.getBoundingClientRect()
      const parent = el.closest('nav').getBoundingClientRect()

      this.shapePos = {
        top: rect.top - parent.top - 8,
        left: rect.left - parent.left - 12,
        width: rect.width + 24,
        height: rect.height + 16,
      }
    },
  })

  Alpine.plugin(collapse)
  Alpine.start()
}

export default () => {}